export const BRANDING_GET_REQUEST = "BRANDING_GET_REQUEST"
export const BRANDINGLIST_GET_SUCCESS = "BRANDINGLIST_GET_SUCCESS"
export const BRANDING_LIST_GET_FAIL = "BRANDING_LIST_GET_FAIL"
